






































import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { NavBar, Cell, CellGroup, Field } from "vant";
import DemoBlock from "@/components/DemoBlock.vue";
import DemoSection from "@/components/DemoSection.vue";
import WeMixin from "@/components/weMixin";
import Jssdk, { WxJsapiSignature } from "@/components/wechat/wechatJssdkMixin";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    DemoBlock,
    DemoSection,
  },
})
export default class DemoQrcodePage extends mixins(WeMixin, Jssdk) {
  private qrcode: string = "";
  private code: string = "";

  protected created() {
    this.initWx().then((wjs: WxJsapiSignature) => {
      this.$wx.config({
        debug: wjs.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wjs.appId, // 必填，公众号的唯一标识
        timestamp: wjs.timestamp, // 必填，生成签名的时间戳
        nonceStr: wjs.nonceStr, // 必填，生成签名的随机串
        signature: wjs.signature, // 必填，签名
        jsApiList: ["scanQRCode"], // 必填，需要使用的JS接口列表
      });
    });
  }

  protected doScan2() {
    if (!this.$wxReady) {
      return;
    }
    this.$wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: (res: any) => {
        this.qrcode = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
      },
    });
  }

  protected doScan1() {
    if (!this.$wxReady) {
      return;
    }
    this.$wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: (res: any) => {
        this.code = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
      },
    });
  }
}
